// extracted by mini-css-extract-plugin
export default {"contentContainer":"ContentList_contentContainer__HziD9","contentSection":"ContentList_contentSection__2t2hN"};